import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import classnames from 'classnames'

export default function Range({ className, ...restProps }) {
  return (
    <>
      <Slider
        {...restProps}
        className={classnames(className, 'slider')}
        renderThumb={(props, state) => <div className='thumb' {...props} />}
        renderTrack={(props, state) => {
          const inset = !Array.isArray(restProps.value)
            ? state.index === 0
            : state.index !== 0 && state.index !== restProps.value.length

          return <div {...props} className={classnames('track', props.className, { inset })} />
        }}
      />

      <style jsx>{`
        :global(.slider) {
          width: 100%;
          height: 1.6rem;
        }

        .track {
          top: 50%;
          bottom: 0;
          transform: translateY(-50%);
          height: 0.6rem;
          background: var(--secondary-input-bg);
          border-radius: 2rem;

          &.inset {
            background: var(--primary-color);
          }
        }

        .thumb {
          height: 1.6rem;
          width: 1.6rem;
          border-radius: 50%;
          line-height: 1.4rem;
          text-align: center;
          background-color: var(--primary-button-bg);
          cursor: grab;
        }

        @media (max-width: 1024px) {
          :global(.slider) {
            height: 2rem;
          }
          .track {
            height: 0.6rem;

            &.inset {
              background: var(--primary-color);
            }
          }
          .thumb {
            height: 2rem;
            width: 2rem;
          }
        }
      `}</style>
    </>
  )
}
